<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onAddNew" />
    <div class="baseDataRect">
      <div class="numList">
        <div @click="onState('Wait')">
          <span>{{ baseData?baseData.numWait:'0' }}</span><br>
          待开始
        </div>
        <div @click="onState('WaitSign')">
          <span>{{ baseData?baseData.numWaitSign:'0' }}</span><br>
          待签约
        </div>
        <div @click="onState('SignFinish')">
          <span>{{ baseData?baseData.numSignFinish:'0' }}</span><br>
          已签约
        </div>
        <div @click="onState('BeginCourse')">
          <span>{{ baseData?baseData.numBeginCourse:'0' }}</span><br>
          待开课
        </div>
        <div @click="onState('CourseIng')">
          <span>{{ baseData?baseData.numCourseIng:'0' }}</span><br>
          开课中
        </div>
        <div @click="onState('Finish')">
          <span>{{ baseData?baseData.numFinish:'0' }}</span><br>
          已完成
        </div>
      </div>
    </div>
    <div class="addRect" @click="onAddNew">
      <span class="icon iconfont iconadd" /><br>
      添加新的顾客
    </div>
    <div class="dataRect">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.order.mermailOrderId" class="baseRect" @click="onClickRect(item.order.hashId)">
          <div class="iconRect">
            <van-image
              width="4em"
              height="4em"
              round
              fit="contain"
              :src="item.userInfo && item.userInfo.icon?item.userInfo.icon:'/dive/defaultIcon.jpg'"
            />
          </div>
          <div class="dataRect">
            <van-row>
              <van-col span="12">创建:<span :style="'color:'+GetColorMain()">{{ formatDate(item.order.createTime,'yyyy/MM/dd hh:mm',true) }}</span></van-col>
              <van-col span="12">状态: <span :style="'color:'+GetColorMain()">{{ GetEnumText('Em_DiveMermaidOrderState',item.order.state) }}</span>
                <van-tag v-if="item.isEsignSigning && item.order.state ==='WaitSign'" style="margin-left:0.5em" type="success">已邀约</van-tag>
                <van-tag v-if="item.isPayFinish===false" style="margin-left:0.5em" type="primary">待支付</van-tag>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="12">姓名:<span :style="'color:'+GetColorMain()">{{ item.order.loaclName }}</span></van-col>
              <van-col span="12">手机号码: <span :style="'color:'+GetColorMain()">{{ item.order.phone }}</span></van-col>
            </van-row>
            <van-row>
              <van-col span="12">课程:<span :style="'color:'+GetColorMain()">{{ item.courseName }}</span></van-col>
              <van-col span="12">开课日期: <span :style="'color:'+GetColorMain()">{{ item.order.courseStartDate?formatDate(item.order.courseStartDate,'yyyy/MM/dd'):'待定' }}</span></van-col>
            </van-row>

            <van-row>
              <van-col span="24" class="autoHide">备注:
                <van-tag v-if="item.order.isSandbox" style="margin-right:0.5em" type="warning">测试订单</van-tag>
                <van-tag v-if="item.isEsignError" style="margin-right:0.5em" type="danger">签约异常,请联系客服</van-tag>
                <span :style="'color:'+GetColorMain()">{{ item.order.remarkAgent }}</span></van-col>
            </van-row>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Tag, List, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Tag.name]: Tag,
    [List.name]: List,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '寻找美人鱼-加盟商中心',
      backurl: '/store/index',
      search: {
        limit: 30,
        page: 1
      },
      loading: undefined,
      finished: false,
      list: [],
      baseData: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.init()
    this.initBase()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    initBase() {
      request({
        url: '/DiveMermaid/getMermaidAgentListInfo',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.baseData = response.data
        this.title = '寻找美人鱼-' + this.baseData.agentName + (this.baseData.isSandbox ? '[测试]' : '')
      })
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
    //   if (this.loading === undefined) {
    //     this.loading = true
    //     return
    //   }
      this.loading = true

      request({
        url: '/DiveMermaid/getMermaidAgentList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onClickRect(hashId) {
      this.$router.push('/mermaid/agent/' + hashId)
    },
    onState() {

    },
    onAddNew() {
      var message = '是否确认添加新的顾客?'
      if (this.baseData.isSandbox) {
        message += '\r\n当前为测试模式，仅作为功能演示,并且在签约完成后不会生成正式的订单!'
      }
      Dialog.confirm({
        title: '添加新的顾客',
        message: message
      }).then(() => {
        this.onAddNewDo()
      })
    },
    onAddNewDo() {
      request({
        url: '/DiveMermaid/createMermaidAgent',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        MyNotify('success', '添加新的顾客成功')
        this.$router.push('/mermaid/agent/' + response.data)
      })
    }
  }
}
</script>
<style scoped>
.addRect{
    background-color: #fff;
    padding: 0.5em;
    margin:1em 0;
    font-size: 0.9em;
    text-align: center;
    color: #999;
}
.baseDataRect {
    background-color: #fff;
    padding: 1em;
}
.baseDataRect .numList{
    display:flex;
}
.baseDataRect .numList div{
    text-align: center;
    flex:1;
    font-size: 0.9em;
    line-height: 1.5em;
}
.baseDataRect .numList span{
    font-size: 1.5em;
    font-weight: 700;
}
.baseRect{
  background-color: #fff;
  padding: 1em;
  margin-bottom: 0.5em;
  position: relative;
  min-height: 4em;
}
.baseRect .iconRect{
  position: absolute;
  left: 1em;
  width: 4em;
  height: 4em;
}
.baseRect .dataRect{
  margin-left: 6em;
  font-size: 0.8em;
}
.baseRect .dataRect span{
  font-weight: 700;
}
.baseRect .autoHide{
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
</style>

